import { IShopMessageBus } from '../types/models'

export class ShopMessageBus implements IShopMessageBus {
    public post(message: any) {
        const element = document.querySelector('#dialog') as HTMLIFrameElement
        if (element && element.tagName.toLocaleLowerCase() === 'iframe') {
            element.contentWindow?.postMessage(message, '*')
        }
    }
}
